import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'dementia_exercise_frequency'

const OPTIONS = [
  {
    value: 'never',
    translationKey: 'pages.onboarding.dementiaExerciseFrequency.options.never',
  },
  {
    value: '1-2',
    translationKey:
      'pages.onboarding.dementiaExerciseFrequency.options.oneToTwo',
  },
  {
    value: '3-4',
    translationKey:
      'pages.onboarding.dementiaExerciseFrequency.options.threeToFour',
  },
  {
    value: '5+',
    translationKey:
      'pages.onboarding.dementiaExerciseFrequency.options.fivePlus',
  },
]

const answers: AnswerType[] = [
  {
    emoji: '🌱',
    title: 'pages.onboarding.dementiaExerciseFrequency.options.never',
    value: 'never',
  },
  {
    emoji: '🧩',
    title: 'pages.onboarding.dementiaExerciseFrequency.options.oneToTwo',
    value: '1-2',
  },
  {
    emoji: '📚',
    title: 'pages.onboarding.dementiaExerciseFrequency.options.threeToFour',
    value: '3-4',
  },
  {
    emoji: '🚀',
    title: 'pages.onboarding.dementiaExerciseFrequency.options.fivePlus',
    value: '5+',
  },
]

export default function DementiaExerciseFrequencyPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const answerValue = input.value

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question:
        'How often do you do physical exercises for brain health (e.g. walking, swimming, dancing)?',
      answer_key: answerValue,
      answer: answerValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.dementiaExerciseFrequency.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
